import { Card } from '@avanta/shared/components/ui/Card';
import Avatar from 'assets/avatar.svg';
import { useUserStore } from 'stores/user';
import { ChangeLanguage } from './components/ChangeLanguage';
import { ChangePassword } from './components/ChangePassword';
import { DeleteAccount } from './components/DeleteAccount';
import { ProfileForm } from './components/ProfileForm';
import { PsychologistBalance } from './components/PsychologistBalance';
import { PsychologistPresentation } from './components/PsychologistPresentation';
import { PsychologistRatings } from './components/PsychologistRatings';

export const Profile = (): React.ReactElement | null => {
  const user = useUserStore(state => state.user);
  const userName =
    user?.firstName && user?.surname
      ? `${user?.firstName} ${user?.surname}`
      : user?.name || user?.nickname;
  const hasFiscalId = user?.nif || user?.cif;

  if (!user) {
    return null;
  }

  return (
    <div className="flex flex-col gap-8">
      <Card className="bg-white">
        <div className="flex flex-col items-center gap-8">
          <div className="w-32 h-32">
            <img
              src={user?.imageCircular || user?.imageSquare || user?.imageURL || Avatar}
              alt="Profile"
              className="rounded-full object-cover"
            />
          </div>
          <div className="flex flex-col items-center gap-1">
            <h2 className="text-2xl font-semibold">{userName}</h2>
            <p className="text-gray-600 text-sm">{user?.email}</p>
            {hasFiscalId && <p className="text-gray-600 text-sm">{user?.nif || user?.cif}</p>}
          </div>
        </div>
      </Card>
      <PsychologistBalance />
      <ProfileForm />
      <ChangePassword />
      <PsychologistPresentation />
      <PsychologistRatings />
      <ChangeLanguage />
      <DeleteAccount />
    </div>
  );
};
